import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4be5f8eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "sm:col-span-2" }
const _hoisted_3 = {
  for: "citta",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
  style: {"display":"inline-block"}
}
const _hoisted_4 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"2%"}
}
const _hoisted_5 = ["aria-hidden"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_10 = { class: "m-b-15" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"position":"absolute"},
  class: "inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5 text-gray-500 dark:text-gray-400",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    id: "search"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
  ])
], -1))
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = ["selected", "value"]
const _hoisted_15 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_16 = { class: "m-b-15" }
const _hoisted_17 = {
  for: "Via di residenza",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_18 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_19 = { class: "m-b-15" }
const _hoisted_20 = {
  for: "Telephone",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_21 = { class: "text-red-500 mb-2 w-full" }

import { ref, onMounted, reactive } from "vue";
import { Input } from 'flowbite-vue'
import debounce from "@/utils/debounce";
import { patientStore } from '@/store/patient'
import { storeToRefs } from 'pinia'
import { getGeoLocation } from "../../../../EshJSLib/services/geoService";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'pazienteAggiuntiveEdit',
  emits: ['cancel'],
  setup(__props, { emit }) {

const store = patientStore();
const { patient } = storeToRefs(store)
let isOpen = ref(false);
let isOpenNas = ref(false);
let cittaRezSc = ref(false);
const error = ref(false);



let currentCityQuery = ref('');
let cityList = ref([]);

let errors = ref([]);

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const showLoading = ref(false);

const isShowModal = reactive({
  mobileNumberError: false,
});


onMounted(() => {
  patient.value.status = "update"

})

function validateFields() {
  errors.value = [];
  errors.value[1] = !patient.value.user.contact_detail.contatto_indirizzo ? 'Questo campo è obbligatorio' : '';
  errors.value[0] = currentCityQuery.value != patient.value.user.contact_detail.comune_residenza && currentCityQuery.value != "" ? 'Seleziona una delle città' : '';
  errors.value[0] = !patient.value.user.contact_detail.comune_residenza ? 'Questo campo è obbligatorio' : '';
  errors.value[2] = !validatePhoneNumber() ? 'Il numero di telefono non è valido!' : '' ;
  return errors.value.filter(error => error !='').length == 0;
}

async function updateValue() {
  localStorage.setItem('patient', JSON.stringify(patient.value));
  patient.value.status = "update";

  const userInput = await alertModal.value?.openModal("Salvare le modifiche ? ", true);
  if (userInput) {
    showLoading.value = true;
    store.saveSchedaPaziente()
    .then(() => {
        showLoading.value = false;
        alertModal.value?.openModal("Salvato con successo! ", false)
        .then(() => emit('cancel'));
        store.refreshScheda(store.patient.id_paziente)
      })
      .catch((res) => {
        showLoading.value = false;
        alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
        store.refreshScheda(store.patient.id_paziente)
      });
  }
}


function validatePhoneNumber() {
  if (!patient.value.user.contact_detail.contatto_telefono )
    return false;
    //eslint-disable-next-line
    const regex1 = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;

  if ( !regex1.test(patient.value.user.contact_detail.contatto_telefono.replaceAll(/\s/g,''))) {
    return false;
  }
  return true;
}


function checkContatto() {
  errors.value = [];
  let val = validateFields();
  if(!val) {
    return false;
  } else {
    updateValue();
  }
}

function switchVis(e) {
  isOpen.value = false;
  error.value = false;
  if (e.target == null) {
    return;
  }
  currentCityQuery.value = e.target.value;
}

const checkCurrentTown = debounce(async () => {
  cittaRezSc.value = true;
  isOpenNas.value = false;
  const response = await getGeoLocation(currentCityQuery.value);
  cityList.value = response;
  isOpen.value = true;
  cittaRezSc.value = false;
}, 700)

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancel')))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiorna') + ' ' + _ctx.$t('informazioni recapiti')), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Città di residenza ")), 1),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("svg", {
              "aria-hidden": !_unref(cittaRezSc),
              class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
              viewBox: "0 0 100 101",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_8, 8, _hoisted_5)),
            _hoisted_9
          ], 512), [
            [_vShow, _unref(cittaRezSc)]
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "citta",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentCityQuery) ? (currentCityQuery).value = $event : currentCityQuery = $event)),
                onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkCurrentTown) && _unref(checkCurrentTown)(...args))),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
              _isRef(isOpen) //@ts-ignore
 ? isOpen.value = true : isOpen = true;
            _isRef(isOpenNas) //@ts-ignore
 ? isOpenNas.value = false : isOpenNas = false;
            }),
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                placeholder: _unref(patient).user.contact_detail.comune_residenza
              }, null, 40, _hoisted_13), [
                [_vModelText, _unref(currentCityQuery)]
              ])
            ]),
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[3] || (_cache[3] = ($event: any) => (switchVis($event))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(patient).user.contact_detail.comune_residenza) = $event)),
              size: "10",
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  selected: item.city,
                  key: item.city,
                  value: item.city
                }, _toDisplayString(item.city), 9, _hoisted_14))
              }), 128))
            ], 544), [
              [_vShow, _unref(isOpen) === true],
              [_vModelSelect, _unref(patient).user.contact_detail.comune_residenza]
            ]),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(errors)[0]), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Via di residenza")), 1),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(patient).user.contact_detail.contatto_indirizzo) = $event)),
            type: "text",
            id: "residenza",
            required: ""
          }, null, 2), [
            [_vModelText, _unref(patient).user.contact_detail.contatto_indirizzo]
          ]),
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(errors)[1]), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("Telephone")), 1),
          _createVNode(_unref(VueTelInput), {
            mode: "international",
            inputOptions: { placeholder: 'Inserisci il numero di telefono' },
            modelValue: _unref(patient).user.contact_detail.contatto_telefono,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(patient).user.contact_detail.contatto_telefono) = $event)),
            defaultCountry: 'IT',
            disabledFetchingCountry: false,
            disabled: false,
            disabledFormatting: false,
            enabledCountryCode: false
          }, null, 8, ["modelValue"]),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(errors)[2]), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          id: "submitRecapiti",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (checkContatto())),
          class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        }, _toDisplayString(_ctx.$t("Salva")), 1)
      ]),
      _: 1
    }),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})